var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var b2cCrumbs = [
    { path: '/', label: 'Home' },
    {
        path: '/myaccount/profile',
        label: 'Account',
    },
];
export var b2cMobileCrumbs = [
    { path: '/', label: 'Home' },
    {
        path: '/myaccount/profile/menu',
        label: 'Account',
    },
];
export var b2bCrumbs = [
    { path: '/', label: 'Home' },
    {
        path: '/b2b/account/view/landingpage',
        label: 'Account',
    },
];
export var getCrumbs = function (label, isB2B, isMobile) {
    if (isB2B)
        return __spreadArray(__spreadArray([], b2bCrumbs, true), [{ label: label }], false);
    return __spreadArray(__spreadArray([], (isMobile ? b2cMobileCrumbs : b2cCrumbs), true), [{ label: label }], false);
};
